import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";
import { useFieldChoices } from "./useFieldChoices";

const HomePropertyFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  const propertyTypes = useFieldChoices("home_property", "property_type");
  const coverageTypes = useFieldChoices("home_property", "coverage_type");

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:home.propertyType')}</label>
        <select
          value={data.property_type || ""}
          onChange={(e) => set("property_type", e.target.value)}
        >
          <option value="">{t('insurance:home.selectPropertyType')}</option>
          {propertyTypes.map((tp) => (
            <option key={tp.value} value={tp.value}>{tp.label}</option>
          ))}
        </select>
      </div>
      <div className="irf-field">
        <label>{t('insurance:home.coverageType')}</label>
        <select
          value={data.coverage_type || ""}
          onChange={(e) => set("coverage_type", e.target.value)}
        >
          <option value="">{t('insurance:home.selectCoverage')}</option>
          {coverageTypes.map((tp) => (
            <option key={tp.value} value={tp.value}>{tp.label}</option>
          ))}
        </select>
      </div>
      <div className="irf-field">
        <label>{t('insurance:home.propertyValue')}</label>
        <input
          type="number"
          value={data.property_value ?? ""}
          onChange={(e) => set("property_value", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:home.propertyValuePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:home.propertyAddress')}</label>
        <input
          value={data.property_address || ""}
          onChange={(e) => set("property_address", e.target.value)}
          placeholder={t('insurance:home.propertyAddressPlaceholder')}
        />
      </div>
    </div>
  );
};

export default HomePropertyFields;
